import { HostBinding, Component, ElementRef, Renderer2, Input } from '@angular/core';
import { BootstrapColor } from '../../global-types';

@Component({
  selector: 'bp-spinner',
  exportAs: 'bpSpinner',
  template: `<span class="sr-only">Loading...</span>`
})
export class BpSpinnerComponent {
  @Input() grow = false;
  @Input() color: BootstrapColor;

  @HostBinding('class') public get _class() {
    let cls = '';
    if (this.color) {
      cls += ` text-${this.color}`;
    }
    if (this.grow) {
      cls += ' spinner-grow';
    } else {
      cls += ' spinner-border';
    }
    return cls;
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.setAttribute(this.el.nativeElement, 'role', 'status');
  }
}
